import { ref } from 'vue';
import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch';
import { ExpensePayment, ExpensePaymentRequest } from '@/interfaces/expense';
import {
  expensesPayments,
  clubUUID,
  expenses,
  expense_regulations_amount,
  expense_regulations_amount_by_day,
} from "@/shared/state";
import { ExpenseRegulationSalesQueryParams } from '@/interfaces/stats';


const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useExpensePayment() {
    const errorExpensePayment = ref<boolean | false>(false);
    const isRequestExpensePayment = ref<boolean | false>(false);
    const getPayments = async (expense_id: number) => {

        try {
            isRequestExpensePayment.value = true
            errorExpensePayment.value = false
            const response = await authenticatedFetch(`${API_URL}expenses-payments/${expense_id}/${clubUUID.value}`, {
                method: 'GET'
            }, false, '', false);
            if (response?.data) {
                expensesPayments.data = response?.data || []
                isRequestExpensePayment.value = false
            }

            isRequestExpensePayment.value = false
        } catch (err: any) {
            errorExpensePayment.value = true;
            isRequestExpensePayment.value = false
        }
    };

    const addPayment = async (body: ExpensePaymentRequest) => {
        try {
            isRequestExpensePayment.value = true
            errorExpensePayment.value = false
            const response = await authenticatedFetch(`${API_URL}expenses-payments/store`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {
                if (response?.data) {
                    const index = expenses?.data?.findIndex(expense => expense?.id === response?.data?.expense_id);
                    if (index !== -1) {
                        expenses.data[index].remaining_amount -= response?.data?.amount_paid ?? 0;
                        expenses.data[index].total_amount_paid += response?.data?.amount_paid ?? 0;
                        if (expenses.data[index].remaining_amount <= 0)
                            expenses.data[index].is_paid = 1
                    }
                }
            }
            isRequestExpensePayment.value = false
        } catch (err: any) {
            errorExpensePayment.value = true;
            isRequestExpensePayment.value = false
        }
    };

    const editPayment = async (body: ExpensePaymentRequest) => {
        try {
            isRequestExpensePayment.value = true
            errorExpensePayment.value = false
            const response = await authenticatedFetch(`${API_URL}expenses-payments/edit/${body?.id}`, {
                method: 'PUT',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {
                const paymentEdited: ExpensePayment = response?.data
                const index = expensesPayments?.data?.findIndex(payment => payment?.id === paymentEdited?.id);
                if (index !== -1) {
                    expensesPayments.data[index] = paymentEdited;
                }
                isRequestExpensePayment.value = false
            }
            isRequestExpensePayment.value = false
        } catch (err: any) {
            errorExpensePayment.value = true;
            isRequestExpensePayment.value = false
        }
    };

    const deletePayment = async (paymentID: number, expenseID: number, amount_paid: number) => {
        try {
            isRequestExpensePayment.value = true
            errorExpensePayment.value = false
            const response = await authenticatedFetch(`${API_URL}expenses-payments/delete/${paymentID}`, {
                method: 'DELETE'
            }, true, '', true);
            const index = expensesPayments?.data?.findIndex(payment => payment?.id === paymentID);
            if (index !== -1) {
                expensesPayments.data.splice(index, 1);

                const indexExpense = expenses?.data?.findIndex(expense => expense?.id === expenseID);
                if (indexExpense !== -1) {
                    expenses.data[indexExpense].remaining_amount += amount_paid ?? 0;
                    expenses.data[indexExpense].total_amount_paid -= amount_paid ?? 0;
                    if (expenses.data[indexExpense].remaining_amount > 0)
                        expenses.data[indexExpense].is_paid = 0
                }
                isRequestExpensePayment.value = false
            }
            isRequestExpensePayment.value = false
        } catch (err: any) {
            errorExpensePayment.value = true;
            isRequestExpensePayment.value = false
        }
    };

    const fetchExpenseRegulationsStats = async (body: ExpenseRegulationSalesQueryParams) => {
        try {
            isRequestExpensePayment.value = true
            errorExpensePayment.value = false
            expense_regulations_amount.data = []
            const response = await authenticatedFetch(`${API_URL}expenses-payments/regulations/stats`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);
            if (response) {

                expense_regulations_amount.data = response?.regulations
                expense_regulations_amount.total = response?.total
                isRequestExpensePayment.value = false
            }
            isRequestExpensePayment.value = false
        } catch (err: any) {
            errorExpensePayment.value = true;
            isRequestExpensePayment.value = false
        }
    };

      const fetchExpenseRegulationsStatsByDay = async (
        body: ExpenseRegulationSalesQueryParams,
      ) => {
        try {
          isRequestExpensePayment.value = true;
          errorExpensePayment.value = false;
          expense_regulations_amount_by_day.data = [];
          const response = await authenticatedFetch(
            `${API_URL}expenses-payments/regulations/stats`,
            {
              method: "POST",
              body: JSON.stringify(body),
            },
            false,
            "",
            false,
          );
          if (response) {
            isRequestExpensePayment.value = false;
            expense_regulations_amount_by_day.data = response?.regulations;
            expense_regulations_amount_by_day.total = response?.total;
          }
          isRequestExpensePayment.value = false;
        } catch (err: any) {
          errorExpensePayment.value = true;
          isRequestExpensePayment.value = false;
        }
      };

    return {
        fetchExpenseRegulationsStatsByDay,
        fetchExpenseRegulationsStats,
        getPayments,
        addPayment,
        editPayment,
        deletePayment,
        isRequestExpensePayment,
        errorExpensePayment
    };
}
